// client/src/components/common/SearchBox.jsx

import React, { useState } from 'react';
import { Search, X } from 'lucide-react';

const SearchBox = ({ onSearch, isSearching }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, '');
    const limited = digits.slice(0, 10);
    
    if (limited.length <= 3) {
      return limited;
    } else if (limited.length <= 6) {
      return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
    } else {
      return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
    }
  };

  const handleInputChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    setPhoneNumber(formatted);
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const digits = phoneNumber.replace(/\D/g, '');
    
    if (digits.length !== 10) {
      setError('Please enter a valid 10-digit phone number');
      return;
    }
    
    onSearch(digits);
  };

  const handleClear = () => {
    setPhoneNumber('');
    setError('');
  };

  return (
    <form onSubmit={handleSubmit} className="relative flex items-center gap-2">
      <div className="relative flex-1">
        <input
          type="text"
          value={phoneNumber}
          onChange={handleInputChange}
          placeholder="Search phone number..."
          disabled={isSearching}
          className={`w-full px-4 py-2 pr-10 text-gray-900 border rounded-lg focus:outline-none focus:ring-2 transition-colors ${
            error 
              ? 'border-red-500 focus:ring-red-500' 
              : 'border-gray-300 focus:ring-blue-500'
          } ${
            isSearching ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'
          }`}
          maxLength={14}
        />
        
        {phoneNumber && !isSearching && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        )}
        
        {isSearching && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
      </div>
      
      <button
        type="submit"
        disabled={isSearching || !phoneNumber}
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors shadow-sm hover:shadow"
      >
        <Search className="w-4 h-4" />
        <span className="hidden sm:inline">Search</span>
      </button>
      
      {error && (
        <div className="absolute -bottom-6 left-0 text-sm text-red-400 font-medium">
          {error}
        </div>
      )}
    </form>
  );
};

export default SearchBox;